import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getContactById } from '../../actions/contact';
import ViewAction from '../actionStream/ViewAction';
import AddAction from '../actionStream/AddAction';
import ViewDeal from '../deal/ViewDeal';
// import AddDeal from '../deal/AddDeal';
import LowerPageView from './LowerPageView';
import ContactHead from './ContactHead';
import ActionBar from '../SideBars/Action';
import { makeStyles } from '@material-ui/core';
import Background from './Background';

const ViewContact = ({ getContactById, contact: { contact }, match }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      marginTop: '1em'
    },
    contactMain: {
      width: '70%'
    }
  }));

  const classes = useStyles();

  useEffect(() => {
    getContactById(match.params.id);
  }, [getContactById, match.params.id]);
  return (
    <div className={classes.root}>
      <div>
        <ActionBar />
      </div>
      <div className={classes.contactMain}>
        <Fragment>
          {contact && contact && (
            <Fragment>
              <ContactHead contact={contact} key={contact._id} />
              <Fragment>
                {contact.action.length > 0 ? (
                  <Fragment>
                    <ViewAction key={contact._id} contactID={contact._id} />
                  </Fragment>
                ) : (
                  <Fragment>
                    <AddAction key={contact._id} contactID={contact._id} />
                  </Fragment>
                )}
                <ViewDeal key={contact._id} contactID={contact._id} />
                <Background key={contact._id} contact={contact} />
              </Fragment>
              <LowerPageView key={contact._id} contact={contact} />
            </Fragment>
          )}
        </Fragment>
      </div>
    </div>
  );
};

ViewContact.propTypes = {
  getContactById: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  contact: state.contact
});

export default connect(mapStateToProps, { getContactById })(ViewContact);



// WEBPACK FOOTER //
// ./src/components/contact/ViewContact.js